/* Product-specific editor blocks feed the two existing price placements. */
(() => {
  if (customElements.get('orkick-product-rating')) return;
  class OrkickProductRating extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => { if (this.isConnected) this.refresh(); });
    }
    refresh() {
      const source = Array.from(document.querySelectorAll('template[data-orkick-rating-source]'))
        .find(item => item.dataset.sectionId === this.dataset.sectionId && item.dataset.productId === this.dataset.productId);
      this.replaceChildren();
      this.hidden = !source;
      if (source) this.append(source.content.cloneNode(true));
    }
  }
  customElements.define('orkick-product-rating', OrkickProductRating);
  const refresh = () => document.querySelectorAll('orkick-product-rating').forEach(slot => slot.refresh());
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:block:select', event => {
    refresh();
    const source = Array.from(document.querySelectorAll('template[data-orkick-rating-source]'))
      .find(item => item.dataset.blockId === event.detail?.blockId);
    if (!source) return;
    const slot = Array.from(document.querySelectorAll('orkick-product-rating'))
      .find(item => item.dataset.sectionId === source.dataset.sectionId && item.dataset.productId === source.dataset.productId && item.getClientRects().length);
    slot?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
  });
  refresh();
})();
